/* eslint-disable camelcase */
import gql from "graphql-tag";
import { mWarn } from "utils/logger";
import { graphQLClientMutationHelper, graphQLQueryHelper } from "utils/graphQL";
import { EDIT_CANDIDATE } from "screens/LoginRegistration/queries";
import getData from "utils/getData";
import { pushClevertapProfile } from "utils/clevertapEvents";
import { getCorrectExperience } from "screens/Profile/utils";
import convertText from "utils/convertText";

export const LIST_FUNCTIONAL_AREAS = gql`
  {
    listFunctionalAreas(first: 150) {
      totalCount
      edges {
        id
        name
        image
      }
    }
  }
`;

export const SUGGEST_COMPANIES = gql`
  query searchCompanies($query: String!) {
    suggestCompanies(query: $query) {
      id
      name
    }
  }
`;

export const searchCompanyQuery = async (query, client) => {
  let companyOptions = [];

  const { data } = await graphQLQueryHelper(client)({
    query: SUGGEST_COMPANIES,
    variables: {
      query
    }
  });

  if (data && data.suggestCompanies) {
    companyOptions = data.suggestCompanies.map((item) => ({
      label: item.name,
      value: item.id
    }));
  }

  // In order to have query as option
  // User can add their own keyword for companies if their companies are not in the list
  companyOptions.push({
    label: convertText(query, "title-case"),
    value: query
  });

  return companyOptions;
};

export const totalExperienceOptions = [
  {
    text: "Fresher",
    value: 0,
    vernacKey: "generic_freshers"
  },
  {
    text: "1-6 months",
    value: 6,
    vernacKey: "generic_one_six_months"
  },
  {
    text: "6 months - 1 year",
    value: 12,
    vernacKey: "generic_six_months_one_year"
  },
  {
    text: "1-2 years",
    value: 24,
    vernacKey: "generic_one_two_years"
  },
  {
    text: "2-3 years",
    value: 36,
    vernacKey: "generic_two_three_years"
  },
  {
    text: "3-4 years",
    value: 48,
    vernacKey: "generic_three_four_years"
  },
  {
    text: "4-5 years",
    value: 60,
    vernacKey: "generic_four_five_years"
  },
  {
    text: "5+ years",
    value: 72,
    vernacKey: "generic_five_plus_years"
  }
];

export const experienceOptions = [
  ...totalExperienceOptions,
  {
    text: "None",
    value: 0
  }
];

export const getExistingFAExperience = ({
  fa_experience,
  functional_areas
}) => {
  let faExperience = {};
  if (fa_experience && fa_experience.length > 0) {
    fa_experience.forEach((experience) => {
      let faIndex = null;

      for (let i = 0; i < functional_areas.length; i += 1) {
        if (
          experience.functional_area &&
          functional_areas[i].id === experience.functional_area.id
        ) {
          faIndex = experience.functional_area.id;
          break;
        }
      }

      const actualExperience = getCorrectExperience(experience.experience);

      if (faIndex !== null) {
        faExperience = {
          ...faExperience,
          [faIndex]: {
            id: experience.id,
            functionAreaId: experience.functional_area
              ? experience.functional_area.id
              : "",
            experience: actualExperience
          }
        };
      }
    });
  }
  return faExperience;
};

export const onSubmitHandler = async ({
  faExperience,
  goNext,
  state,
  client
}) => {
  const { user } = state;

  const payload = {
    fa_experience: Object.values(faExperience).map((data) => {
      let faExperienceObj = {
        functional_area_id: data.functionAreaId,
        experience: data.experience
      };
      if (data.id) {
        faExperienceObj = { ...faExperienceObj, id: data.id };
      }
      return faExperienceObj;
    })
  };

  const SiteObj = {};

  let FATotalExperience = 0;
  const FaMapping = Object.values(faExperience).map((data, index) => {
    FATotalExperience += data.experience;
    SiteObj[`Experience_FA${index + 1}`] = data.experience;
  });

  pushClevertapProfile({
    Identity: user.id,
    Candidate_Total_Work_Exp: FATotalExperience,
    ...SiteObj
  });

  const { data, error } = await graphQLClientMutationHelper(client)({
    mutation: EDIT_CANDIDATE,
    variables: { id: user?.stakeholder?.id, payload }
  });

  if (error) {
    mWarn("error", error);
    return;
  }

  if (data && data.edit) {
    const userData = {
      ...user,
      stakeholder: {
        ...user.stakeholder,
        fa_experience: getData(data, "edit.fa_experience")
      }
    };

    goNext({
      user: userData
    });
  }
};
